import React from 'react';
import { EventLayoutChoice, EventTransactionPartiesLayoutProps } from '../types';
import { Cell, CheckboxInput, ErrorsWrapper, List, Text, useShowContextRequired } from 'ui-builder';
import { BriefcaseCheckbox, GridLayout, GridLayoutTheme } from 'features/nekst-widgets';

import styles from '../../../TransactionParties.module.scss';

function BriefcaseAssignmentInput(
  props: {
    onChange: (personId: number) => void,
  }
) {
  const showContext = useShowContextRequired<EventLayoutChoice>();

  const data =  showContext.data!;

  return (
    <BriefcaseCheckbox
      source="isAssigned"
      onChangeCallback={() => {
        props.onChange(data.id);
      }}
      label={(
        <>
          {data.name}
          {data.nameHint && (
            <Text className={styles.roles}>
              {data.nameHint}
            </Text>
          )}
        </>
      )}
      value={data.isAssigned}
    />
  );
}

function InviteToEventCheckbox(
  props: {
    onChange: (personId: number) => void,
  }
) {
  const showContext = useShowContextRequired<EventLayoutChoice>();

  return (
    <CheckboxInput
      source="isInvited"
      onChangeCallback={() => {
        props.onChange(showContext.data!.id);
      }}
      value={showContext.data!.isInvited}
      hideLabel
    />
  );
}

export default function EventTransactionPartiesLayoutWeb(
  props: EventTransactionPartiesLayoutProps
) {
  const assignmentsCount = props.choices
    .filter((item) => item.isAssigned)
    .length;

  return (
    <ErrorsWrapper name="inviteRecipients">
      <ErrorsWrapper name="transactionParties">
        <List
          getDataFunc={async () => props.choices}
          dependencies={[JSON.stringify(props.choices)]}
        >
          <GridLayout theme={GridLayoutTheme.TINY} weights={[8, 4]}>
            <Cell label={`Assigned To (${assignmentsCount}):`} isCentered={false}>
              <BriefcaseAssignmentInput
                onChange={(personId) => props.onAssignmentChangedCallback(personId)}
              />
            </Cell>
            <Cell label="Invite to Appt:">
              <InviteToEventCheckbox onChange={(personId) => props.onInvitationChangedCallback(personId)} />
            </Cell>
          </GridLayout>
        </List>
      </ErrorsWrapper>
    </ErrorsWrapper>
  );
}
